module.exports = __webpack_public_path__ + "img/rot07.873de345.jpg";